var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "registration-step-indicator-wrapper" }, [
    _c(
      "div",
      { staticClass: "registration-step-indicator" },
      _vm._l(_vm.steps, function(item) {
        return _c(
          "a",
          {
            key: item.key,
            attrs: {
              href:
                item.type != "separator" &&
                _vm.stepCompleted[item.key] &&
                !_vm.disableLinks
                  ? item.href
                  : null
            }
          },
          [
            _c(
              "span",
              {
                class: {
                  step: item.type != "separator",
                  separator: item.type == "separator",
                  active: item.key == _vm.step
                }
              },
              [
                item.type != "separator" && _vm.stepCompleted[item.key]
                  ? _c("i", { staticClass: "material-icons check" }, [
                      _vm._v("check_circle")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("custom-icon", {
                  staticClass: "step-icon",
                  attrs: { name: item.icon, active: item.key == _vm.step }
                }),
                _vm._v(" "),
                item.type != "separator"
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.$t("registration.step-" + item.key)))
                    ])
                  : _vm._e()
              ],
              1
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8c5322ee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c5322ee","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/StepIndicatorComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-8c5322ee","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/StepIndicatorComponent.vue
// module chunks = 1 2 3